import { render, staticRenderFns } from "./registeringCompany.vue?vue&type=template&id=36ad364c&scoped=true&"
import script from "./registeringCompany.vue?vue&type=script&lang=js&"
export * from "./registeringCompany.vue?vue&type=script&lang=js&"
import style0 from "./registeringCompany.vue?vue&type=style&index=0&id=36ad364c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ad364c",
  null
  
)

export default component.exports